module.exports = __webpack_public_path__ + "img/241.6b18bd6a.png";